import { NavLink, Outlet, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import LanguageToggle from "@/components/language-toggle";
import { Sparkle, ChartLine, UserPlus, UsersThree, Share, Gift, Newspaper, SignOut, UserGear } from "@phosphor-icons/react";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const { t } = useLang();

  const items = [
    { to: "/admin", label: t.admin.analytics, icon: ChartLine, end: true, testid: "adm-nav-analytics" },
    { to: "/admin/applications", label: t.admin.applications, icon: UserPlus, testid: "adm-nav-applications" },
    { to: "/admin/ambassadors", label: t.admin.ambassadors, icon: UsersThree, testid: "adm-nav-ambassadors" },
    { to: "/admin/staff", label: t.admin.staff, icon: UserGear, testid: "adm-nav-staff" },
    { to: "/admin/referrals", label: t.admin.referrals, icon: Share, testid: "adm-nav-referrals" },
    { to: "/admin/rewards", label: t.admin.rewards, icon: Gift, testid: "adm-nav-rewards" },
    { to: "/admin/content", label: t.admin.content, icon: Newspaper, testid: "adm-nav-content" },
  ];

  return (
    <div className="min-h-screen flex bg-[#0b1521] text-white">
      <aside className="hidden md:flex w-64 flex-col border-r border-white/10">
        <div className="px-6 py-6 border-b border-white/10">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-[#f4a261] flex items-center justify-center">
              <Sparkle size={16} weight="fill" color="#0d3b66" />
            </div>
            <span className="font-serif-display text-xl">{t.brand}</span>
          </Link>
          <div className="text-[10px] tracking-widest uppercase text-white/50 mt-2">{t.admin.title}</div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {items.map((it) => (
            <NavLink
              key={it.to} to={it.to} end={it.end} data-testid={it.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-full text-sm ${
                  isActive ? "bg-[#f4a261] text-[#0b1521]" : "text-white/80 hover:bg-white/5"
                }`
              }
            >
              <it.icon size={18} weight="duotone" />
              {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <div className="text-sm">{user?.name}</div>
          <div className="text-xs text-white/50">{user?.email}</div>
          <button data-testid="admin-logout-btn" onClick={logout} className="mt-4 w-full inline-flex items-center gap-2 justify-center px-3 py-2 rounded-full border border-white/15 text-sm hover:bg-white/5">
            <SignOut size={14} /> {t.nav.logout}
          </button>
        </div>
      </aside>

      <div className="flex-1 min-w-0">
        <header className="border-b border-white/10 sticky top-0 z-10 bg-[#0b1521]/80 backdrop-blur-xl">
          <div className="px-6 md:px-10 py-4 flex items-center justify-between">
            <div className="md:hidden font-serif-display text-lg">{t.admin.title}</div>
            <div className="ml-auto flex items-center gap-3">
              <LanguageToggle />
            </div>
          </div>
          <div className="md:hidden flex overflow-x-auto gap-2 px-4 pb-3">
            {items.map((it) => (
              <NavLink key={it.to} to={it.to} end={it.end} className={({ isActive }) => `whitespace-nowrap px-3 py-1.5 rounded-full text-xs ${isActive ? "bg-[#f4a261] text-[#0b1521]" : "bg-white/5 border border-white/10"}`}>
                {it.label}
              </NavLink>
            ))}
          </div>
        </header>
        <main className="px-6 md:px-10 py-8 max-w-7xl">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
